import React, { type ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@fs/zion-ui'
import { ContentAdd } from '@fs/zion-icon'

export default function AddDiscussionButton(buttonProps: Partial<ComponentProps<typeof Button>>): JSX.Element {
  const [t] = useTranslation()
  return (
    <Button Icon={ContentAdd} data-testid="add-discussion-button" {...buttonProps}>
      {t('tree-person.add-discussion.action')}
    </Button>
  )
}
